<!--
     <IndicatorFormula
       :metrics="metrics"
       :metrics_formula="'sum'"
     />
-->

<template>
  <div class="info-f-cont">
    <div class="info-f-left">
      NPR
    </div>

    <div class="info-f-equal">=</div>

    <div class="info-f-right">
      <div class="info-f-term-cont">
        <div
          v-for="metric, index in metrics"
          :key="metric.id"
          class="info-f-term"
        >
          <span v-if="index > 0" class="info-f-plus">
            <span v-if="metrics_formula == 'sum'">+</span>
            <span v-if="metrics_formula == 'mul'">×</span>
          </span>
          <span>(</span>
          <span v-if="metric.weight < 1 || metric.weight > 1">
            {{ metric.weight }}
          </span>
          <span
            v-if="metric.weight < 1 || metric.weight > 1"
            style="padding: 0px 4px 0px 4px;">
            ×
          </span>
          <span>
            {{ metric.name }}
          </span>
          <span>)</span>
        </div>
      </div>
    </div>
  </div>
</template>


<style lang="scss">
 .info-f-cont {
   display: flex;
   flex-direction: row;
   flex-wrap: nowrap;
   gap: 12px;
 }

 .info-f-left {
   display: flex;
   flex-direction: row;
   align-items: center;
   justify-content: center;
 }

 .info-f-equal {
   font-size: 22px;
 }

 .info-f-right {
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
   gap: 0px;
 }

 .info-f-plus {
   display: block;
   width: 32px;
   text-align: center;
 }

 .info-f-term-cont {
   display: flex;
   flex-direction: row;
   flex-wrap: wrap;
   align-items: center;
 }

 .info-f-term {
   display: flex;
   flex-direction: row;
   flex-wrap: nowrap;
 }
</style>


<script>
 export default {
   name: 'IndicatorFormula',

   props: {
     metrics: {required: true},
     metrics_formula: {required: true},
   },

   components: {
   },

   data: (() => ({
     // :)
   })),

   mounted() {
   },

   computed: {
   },

   methods: {
   },
 }
</script>
